module.exports = __webpack_public_path__ + "static/0050-44488ccc05e03359eb916c722f2eed9e.png";